// ============================================================================
// MODULAR DESIGN PRINCIPLES (MANDATORY)
// ============================================================================
// This file strictly follows:
// 1. Single Responsibility Principle - Each module does ONE thing
// 2. Separation of Concerns - Logic separated from presentation
// 3. Modular Architecture - Independent, reusable components
//
// Refer to: docs/architecture/modular-design-standards.md
// ============================================================================

/** CustomEvent name: successful authenticated API usage (debounced) extends idle session. */
export const SESSION_ACTIVITY_EVENT = 'nexus-session-activity';

/** Minimum gap between API-driven activity signals (ms). */
export const API_SESSION_ACTIVITY_DEBOUNCE_MS = 15000;
